import { environment } from '@env/environment';

const { apiUrl } = environment;

/**
 * ### **UbicationEndpoint**
 *
 * Los endpoints son las URLs de un API o un backend que responden a una petición, en este caso las relacionadas a las ubicaciones.
 */
export class UbicationEndpoint {
  /** Endpoint que retorna la información de las ciudades*/
  static municipalities = `${apiUrl}ubication/city/`;
  /** Endpoint que retorna la información de los paises*/
  static country = `${apiUrl}ubication/country/`;
  /** Endpoint que retorna la información de los departamentos*/
  static departaments = `${apiUrl}ubication/state/`;
  /** Endpoint que retorna la información de los departamentos*/
  static provinces = `${apiUrl}ubication/state/`;
  /** Endpoint que retorna la información de todos los departamentos*/
  static departaments_all = `${apiUrl}ubication/state_all`;
  /** Endpoint que retorna la información solo los municipios*/
  static municipios_new = `${apiUrl}ubication/citysingle/`;
}
